// Mock data for Bulls On Parade - Ontario Darts Hub
// NOTE: All data here is MOCKED for a frontend-only clone.
// Images reference the original deployment for a pixel-perfect look.

const DPL = "dpl_BvJPNh8bLyWyaB3FayBj4Vixd5WR";
const BASE = process.env.REACT_APP_IMAGE_BASE_URL || "https://bulls-on-parad-bv549d.vercel.app";

// Build a Next.js optimized image URL matching the original site
export const img = (rel, w = 1200) =>
  `${BASE}/_next/image?url=${encodeURIComponent("/images/" + rel)}&w=${w}&q=75&dpl=${DPL}`;

// All contact routes to the owner's email
export const CONTACT_EMAIL = "stoddartbrad13@gmail.com";
export const mailto = (reason = "General enquiry") =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Bulls on Parade Darts — " + reason)}`;

export const externalLinks = {
  gofundme: "https://gofund.me/f993a899a",
  discord: "https://discord.com/invite/autodarts",
  companionApp: "https://bulls-parade-pro.base44.app/",
  spotify: "https://open.spotify.com/artist/3uLyKsEb7Is3S4lqwSgaLm",
  youtube: "https://www.youtube.com/",
  email: "stoddartbrad13@gmail.com",
};

export const heroStats = [
  { big: "Weekly", small: "coaching sessions for adults" },
  { big: "Youth", small: "darts academy, all skill levels" },
  { big: "Ontario", small: "wide sponsor & supply network" },
];

export const programs = [
  {
    title: "Adult Coaching",
    body:
      "Small-group and one-on-one sessions covering grip, stance, checkout strategy, and match temperament — for beginners through league regulars.",
    cta: "Register for a session",
    to: "/programs#coaching",
  },
  {
    title: "Youth Darts Academy",
    body:
      "A welcoming program for young throwers, run by coaches who make the fundamentals stick.",
    cta: "Learn more",
    to: "/programs#youth-academy",
  },
  {
    title: "Pro Shop",
    body:
      "Darts, boards, cabinets, and accessories on display — contact us directly to order.",
    cta: "Browse the shop",
    to: "/programs#supplies",
  },
];

export const stayInGame = [
  {
    title: "Tournament Calendars",
    body: "WODA, EODA, NDFC, CDC, WDF, PDC, Vault & ADC, all in one place",
    to: "/tournament-calendars",
    external: false,
  },
  {
    title: "Community Chat",
    body: "Talk darts with players around the world, any hour",
    to: externalLinks.discord,
    external: true,
  },
  {
    title: "Bulls on Parade Darts",
    body: "Our companion app for stats, matches, and more",
    to: externalLinks.companionApp,
    external: true,
  },
];

// Curated representative subset of the pro-shop catalog (original has 200+).
const raw = [
  ["Mission Flight — Orange", "mission-flight-orange"],
  ["Mission Flight — Blue/Green", "mission-flight-blue-green"],
  ["Mission Flight — Yellow", "mission-flight-yellow"],
  ["Mission Flight — Grey", "mission-flight-grey"],
  ["Shot Flight — Grey", "shot-flight-grey-grid"],
  ["Shot Flight — Blue/Red/Gold", "shot-flight-burst-a"],
  ["Shot Flight — Black/Gold", "shot-flight-black-gold"],
  ["Shot Flight — Black", "shot-flight-black-original"],
  ["Shot Flight — White/Red", "shot-flight-white-red"],
  ["Shot Flight — Red/Black", "shot-flight-red-black-redline"],
  ["Shot Flight — Peach/Blue/Gold", "shot-flight-burst-b"],
  ["Shot Flight — Black/Silver", "shot-flight-black-silver"],
  ["Shot Flight — White/Purple/Green", "shot-flight-white-purple-green"],
  ["Shot Flight — Purple/Gold", "shot-flight-purple-gold"],
  ["Shot Flight — Brown/Gold", "shot-flight-brown-gold"],
  ["Shot Flight — Red/Gold", "shot-flight-red-gold"],
  ["Shot Flight — Tan/Gold", "shot-flight-tan-gold"],
  ["Shot Flight — Red/Black Tribal", "shot-flight-red-black-tribal"],
  ["Shot Shaft — Black", "shot-shaft-black-a"],
  ["Shot Shaft — Silver", "shot-shaft-silver"],
  ["Shot Shaft — Black Ringed", "shot-shaft-black-ringed"],
  ["Shot Shaft — Green/Black", "shot-shaft-green-black"],
  ["Elkadart Flight — Black/Red", "elkadart-flight-black-red"],
  ["Elkadart Flight — Blue Bull", "elkadart-flight-blue-bull"],
  ["Elkadart Flight — Lightning", "elkadart-flight-lightning"],
  ["Elkadart Flight — Green Monster", "elkadart-flight-green-monster"],
  ["Elkadart Flight — Blue Mermaid", "elkadart-flight-blue-mermaid"],
  ["Elkadart Flight — Red Dragon", "elkadart-flight-red-dragon"],
  ["Elkadart Flight — Frog & Stars", "elkadart-flight-frog-stars"],
  ["Elkadart Flight — No Bull", "elkadart-flight-no-bull"],
  ["GWS Flight — Holographic Pegasus", "gws-flight-holographic-pegasus"],
  ["GWS Flight — Supersonic", "gws-flight-supersonic"],
  ["GWS Flight — Great Britain", "gws-flight-great-britain"],
  ["GWS Flight — Holographic Toucan", "gws-flight-holographic-toucan"],
  ["GWS Flight — Sharpshooter", "gws-flight-sharpshooter"],
  ["GWS Flight — Tie-Dye", "gws-flight-tie-dye"],
  ["GWS Flight — Holographic Stars", "gws-flight-holographic-stars"],
  ["GWS Flight — Guinness", "gws-flight-guinness"],
  ["GWS Flight — I Love Darts", "gws-flight-i-love-darts"],
  ["GWS Shaft — Clear", "gws-shaft-clear"],
  ["GWS Shaft — Blue", "gws-shaft-blue"],
  ["GWS Shaft — Red", "gws-shaft-red"],
  ["Poly Metronic Flight — Black", "poly-metronic-flight-black"],
  ["Poly Metronic 180 Flight — Blue", "poly-metronic-flight-180-blue"],
  ["Christmas Santa Flight — Green", "christmas-santa-flight-green"],
  ["Elephant Flight — Green", "elephant-flight-green"],
  ["Harrows Triad Flight — Red/Blue", "harrows-triad-flight-red-blue"],
  ["DMI Unicorn Flight — Black", "dmi-unicorn-flight-black"],
  ["Holographic Eyes Flight — Purple", "holographic-eyes-flight-purple"],
  ["Unicorn Rainbow Flight — Black", "unicorn-rainbow-flight-black"],
  ["Flame Flight — Yellow/Black", "flame-flight-yellow"],
  ["Flame Flight — Red/Black", "flame-flight-red"],
  ["Diamond Flight — Blue", "diamond-flight-blue"],
  ["Matrix Code Flight — Green", "matrix-code-flight-green"],
  ["Racing Stripe Flight — Red/Blue", "racing-stripe-flight-red-blue"],
  ["Cherry Blossom Flight — Pink", "cherry-blossom-flight-pink"],
  ["Flight — Canada Maple Leaf", "flight-canada-maple-leaf"],
  ["Lightning Bolt Flight — Yellow/Orange", "lightning-bolt-flight-yellow"],
];

export const supplies = raw.map(([name, file], i) => ({
  id: i + 1,
  name,
  price: "$3/pack",
  image: img("supplies/" + file + ".webp"),
}));

export const usedDarts = {
  tag: "Used / Pre-Owned",
  title: "Dark Finish Steel-Tip Set",
  price: "$70",
  desc:
    "A set of two dark bronze barrels with a turquoise textured grip, sold as a pair. Each dart was weighed on a calibrated scale before listing — photos of both readings are included so you know exactly what you’re getting.",
  bullets: [
    "Steel-tip barrels, dark finish",
    "Verified weight, ~25–26g each",
    "Sold as-is, direct from the owner",
  ],
  images: [
    { src: img("used-darts/used-darts-pair.webp"), caption: "Sold as a pair" },
    { src: img("used-darts/used-darts-weight-verify-1.webp"), caption: "Dart 1 — 26.06g" },
    { src: img("used-darts/used-darts-weight-verify-2.webp"), caption: "Dart 2 — 25.09g" },
  ],
};

export const sponsors = [
  { name: "All About Billiards", place: "Sarnia, Ontario" },
  { name: "Shot Darts", place: "" },
  { name: "FGBradleys", place: "Oshawa" },
  { name: "Play It Direct", place: "" },
  { name: "Shooting Blanks Apparel", place: "" },
  { name: "CSG Dart Supplies", place: "" },
  { name: "Vis Technical Sportswear", place: "Italy" },
  { name: "Power Stride", place: "Sialkot, Pakistan" },
];

export const tournamentBodies = [
  { abbr: "CDC", name: "Championship Darts Circuit", region: "North America", url: "https://champdarts.com/main-tour/" },
  { abbr: "NDFC", name: "National Darts Federation of Canada", region: "Canada", url: "https://www.ndfc.ca/calendar/93/ADULT-TOURNAMENTS" },
  { abbr: "WODA", name: "Western Ontario Darts Association", region: "Ontario", url: "https://www.westernontariodarts.ca/calendar/woda-calendar/" },
  { abbr: "EODA", name: "Eastern Ontario Darts Association", region: "Ontario", url: "https://eoda.ca/adult.html" },
  { abbr: "WDF", name: "World Darts Federation", region: "International", url: "https://dartswdf.com/calendar" },
  { abbr: "PDC", name: "Professional Darts Corporation", region: "International", url: "https://www.pdc.tv/calendar/" },
  { abbr: "Vault", name: "DartConnect Vault", region: "Online", url: "https://dartscircuit.com/events/vault/" },
  { abbr: "ADC", name: "Amateur Darts Circuit (Autodarts)", region: "Online", url: "https://amateurdarts.eu/CALENDAR/" },
];

// Representative 2026 schedule pulled from the associations' public calendars.
export const upcomingTournaments = [
  { date: "Feb 6\u20138, 2026", event: "Frostbite Open", org: "NDFC / WODA / EODA", location: "Ontario" },
  { date: "Feb 6\u201328, 2026", event: "CDC Q-School (virtual)", org: "CDC", location: "Online" },
  { date: "Mar 15, 2026", event: "WODA Spring Open", org: "WODA / NDFC", location: "Western Ontario" },
  { date: "Apr 12, 2026", event: "Dan Cruickshank Memorial", org: "NDFC / WODA", location: "Ontario" },
  { date: "Apr 17\u201318, 2026", event: "Marjorie Allardyce Memorial", org: "EODA", location: "Eastern Ontario" },
  { date: "Apr 18\u201319, 2026", event: "EODA Provincial Championships", org: "EODA", location: "Eastern Ontario" },
  { date: "May 9, 2026", event: "US Darts Masters Qualifier 1", org: "CDC", location: "Niagara, ON" },
  { date: "May 23\u201324, 2026", event: "Toronto Area Open", org: "NDFC", location: "Toronto, ON" },
  { date: "Jun 5, 2026", event: "US Darts Masters Qualifier 2", org: "CDC", location: "Philadelphia, PA" },
  { date: "Jun 21, 2026", event: "Canadian Open", org: "NDFC", location: "Canada" },
  { date: "Jun 22\u201325, 2026", event: "Adult National Championships", org: "NDFC", location: "Canada" },
  { date: "Jul 26, 2026", event: "Motor City Classic", org: "NDFC / WODA", location: "Windsor, ON" },
  { date: "Nov 8, 2026", event: "WODA Fall Classic", org: "WODA / NDFC", location: "Western Ontario" },
];

export const media = {  hero: img("hero-dartboard.webp", 1920),
  coaching: img("coaching-session.webp", 1920),
  youthLogo: img("youth-darts-academy-logo.webp", 828),
  youth: img("youth-academy.webp", 1920),
  sponsorsVenue: img("sponsors-venue.webp", 1920),
};
